import { Pagination } from '@toctoc/design-system';
import { IPaginationIndex } from './Pagination.interfaces';
import { useAppDispatch } from 'src/app/hooks'
import { setPage } from 'src/app/reducers/filters'
import { Grid } from '@mui/material'
import { ChangeEvent } from 'react';
import { getDataAttributes } from '@/utils/object';

export const PaginationIndex = (dataPagination: IPaginationIndex) => {

	const { totalPropiedades, ...props } = dataPagination;
	const dispatch = useAppDispatch();
	const dataAttr = getDataAttributes(props)
	const handlePagination = (event: ChangeEvent<unknown>, value: number) => {
		dispatch(setPage(value))
	}

	return (
		<div>
			<Grid container justifyContent={{ md: 'flex-end'} }sx={{padding : '24px 0px'}} >
				<Pagination
					count={Math.ceil(totalPropiedades / 20)}
					defaultPage={1}
					handlePagination={handlePagination}
					{...dataAttr}
				/>
			</Grid>
		</div>
	)
}
